<div class="currency__wrapper flex flex-col gap-[0.94rem] md:flex-row">
  <!-- Naira -->
  <div
    class="flex min-w-[17.8125rem] flex-col rounded-[0.9375rem] bg-gradient-to-r from-mango-grey to-[#786440] px-5 py-[1.19rem] text-white"
  >
    <p class="text-xs font-normal leading-[1.125rem]">Naira Portfolio</p>
    <p class="text-3xl font-extrabold leading-[3.75rem]">
      ₦ {{ nairaWalletBalance / 100 | number: '1.2-2' }}
    </p>
  </div>

  <!-- Dollar  -->
  <div
    class="flex min-w-[17.8125rem] flex-col rounded-[0.9375rem] bg-gradient-to-r from-mango-grey to-[#786440] px-5 py-[1.19rem] text-white"
  >
    <p class="text-xs font-normal leading-[1.125rem]">
      Dollar Portfolio Balance
    </p>
    <p class="text-3xl font-extrabold leading-[3.75rem]">
      $ {{ dollarWalletBalance / 100 | number: '1.2-2' }}
    </p>
  </div>
</div>

<!--Search Input and Filter-->
<div class="flex items-baseline gap-4">
  <app-filters [filters]="filterStructure"></app-filters>
  <button
    *ngIf="accountId"
    mango-button
    class="bottom-0 w-fit shrink-0 items-center"
    style="display: flex; align-items: center; padding: 0.64rem"
    [disabled]="isLoading"
    (click)="router.url.includes('mutual-funds') ? exportMFDTransactions() : exportNavReport()"
  >
    <span *ngIf="isLoading" spin></span>
    {{ isLoading ? 'Exporting...' : 'Export Report' }}
  </button>
</div>

<div
  [ngClass]="{
    'flex-row gap-14 pb-10 ':
      (isEmptyNairaChart$ | async) === false ||
      (isEmptyDollarChart$ | async) === false
  }"
  class="my-[0.94rem] flex flex-col items-center gap-3 bg-white p-4 md:flex-row md:flex-wrap md:justify-between"
>
  @if ((isEmptyNairaChart$ | async) === true) {
    <div
      class="inline-flex w-full items-center gap-[0.9rem] rounded-xl bg-mango-floralWhite px-[0.6rem] py-[0.9rem]"
    >
      <img
        src="assets/images/svgs/info-circle--yellow.svg"
        alt=""
        class="h-[1.5625rem] w-[1.5625rem]"
      />
      <p class="text-sm leading-[1.3125rem] text-mango-grey">
        NGN portfolio is zero
      </p>
    </div>
  } @else {
    <div class="h-80 w-80">
      <h3 class="text-center">NGN Portfolio</h3>
      <canvas [id]="ngnCanvasId" height="100" width="100"></canvas>
    </div>
  }

  @if ((isEmptyDollarChart$ | async) === true) {
    <div
      class="inline-flex w-full items-center gap-[0.9rem] rounded-xl bg-mango-floralWhite px-[0.6rem] py-[0.9rem]"
    >
      <img
        src="assets/images/svgs/info-circle--yellow.svg"
        alt=""
        class="h-[1.5625rem] w-[1.5625rem]"
      />
      <p class="text-sm leading-[1.3125rem] text-mango-grey">
        USD portfolio is zero
      </p>
    </div>
  } @else {
    <div class="h-80 w-80">
      <h3 class="text-center">USD Portfolio</h3>
      <canvas [id]="usdCanvasId" height="100" width="100"></canvas>
    </div>
  }
</div>

<div>
  <!-- Tabs for mobile -->
  <div class="scroll-wrapper w-full overflow-hidden">
    <div
      class="scroll-container box-border w-full overflow-x-auto whitespace-nowrap p-[10px] sm:hidden"
    >
      <div class="scroll-content inline-block">
        @for (path of pathMap; track $index) {
          <a
            [routerLink]="path.route"
            [ngClass]="{
              'bg-mango-lightOrange text-mango': router.url.includes(
                path.route
              ),
            }"
            class="badge mr-[10px] inline-block cursor-pointer whitespace-nowrap text-wrap rounded-[100px] border border-solid border-gray-400 px-[21px] py-[9px] text-gray-500"
          >
            {{ path.label | titlecase }}
          </a>
        }
      </div>
    </div>
  </div>

  <!-- Tabs for desktop -->
  <div class="hidden w-max rounded-lg bg-white sm:block">
    <nav class="flex w-fit space-x-4 p-[0.31rem]" aria-label="Tabs">
      @for (path of pathMap; track $index) {
        <a
          [routerLink]="path.route"
          [ngClass]="{
            'bg-mango-lightOrange text-mango': router.url.includes(
              path.route
            ),
          }"
          class="rounded-lg px-[0.94rem] py-[0.31rem] text-sm font-normal text-gray-500 hover:bg-gray-50"
          ><span>{{ path.label }}</span></a
        >
      }
    </nav>
  </div>
</div>
<!-- table skeleton loader
<div *ngIf="isFetchingPortfolioList$ | async" class="mt-[0.94rem]">
  <app-table-skeleton-loader></app-table-skeleton-loader>
</div> -->


<router-outlet></router-outlet>